"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _vuedraggable = _interopRequireDefault(require("vuedraggable"));
var _Autocomplete = _interopRequireDefault(require("@/ui/components/Autocomplete"));
var _DialogAlert = _interopRequireDefault(require("@/ui/components/DialogAlert"));
var _vueTheMask = require("vue-the-mask");
var _vuex = require("vuex");
var _lodash = _interopRequireDefault(require("lodash"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var _default2 = exports.default = {
  name: 'ModalNewTypeService',
  components: {
    TheMask: _vueTheMask.TheMask,
    Autocomplete: _Autocomplete.default,
    draggable: _vuedraggable.default
  },
  props: {
    showModal: {
      type: Boolean,
      default: false
    },
    activities: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    closedModal: {
      type: Function,
      default: function _default() {}
    },
    itemEdit: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      isOpen: null,
      farms: [],
      products: [],
      listCustomFields: [],
      selectedCustomFields: [],
      listStepTypes: [],
      newServiceModel: {
        name: '',
        description: '',
        tool: '',
        templates: [],
        followUpActivity: null,
        followUpPeriod: null,
        recurrenceType: null,
        products: [],
        farms: []
      },
      errors: [],
      successorServices: ['Colheita', 'Plantação', 'Corte'],
      quantitys: null,
      deadlines: [{
        description: 'Dia',
        value: 'DAY'
      }, {
        description: 'Semana',
        value: 'WEEK'
      }, {
        description: 'Mês',
        value: 'MONTH'
      }]
    };
  },
  computed: {
    isEdit: function isEdit() {
      return this.itemEdit && this.itemEdit.id;
    },
    CFjoineds: function CFjoineds() {
      var items = this.selectedCustomFields.map(function (i) {
        return i.id;
      });
      return items;
    },
    title: function title() {
      if (!this.isEdit) return 'Novo tipo de serviço';
      return 'Editar tipo de serviço';
    }
  },
  mounted: function mounted() {
    this.getAsyncProduct();
    if (this.itemEdit && this.itemEdit.id) {
      this.checkService(this.itemEdit);
    }
  },
  methods: _objectSpread(_objectSpread({}, (0, _vuex.mapActions)(['fetchFarms', 'fetchProducts', 'getCustomFields', 'getLinkedCustomFields', 'getLinkedServiceStepTypes', 'createServiceStepType', 'deleteServiceStepType', 'saveNewTypeService', 'editTypeService', 'execUnlinkCustomField', 'execLinkCustomFields', 'getServiceTypes'])), {}, {
    checkService: function checkService(service) {
      this.newServiceModel = this.itemEdit;
      if (!service.hasOwnProperty('products')) this.newServiceModel.products = [];
      if (!service.hasOwnProperty('farms')) this.newServiceModel.farms = [];
      delete this.newServiceModel.createdAt;
      delete this.newServiceModel.updatedAt;
      this.getStepTypesLinked();
    },
    getStepTypesLinked: function () {
      var _getStepTypesLinked = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var data;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return this.getLinkedServiceStepTypes(this.itemEdit.id);
            case 1:
              data = _context.v;
              if (data) {
                this.listStepTypes = data;
              }
            case 2:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function getStepTypesLinked() {
        return _getStepTypesLinked.apply(this, arguments);
      }
      return getStepTypesLinked;
    }(),
    closedModalNewService: function closedModalNewService() {
      this.errors = [];
    },
    resolved: function resolved() {
      var item = this.newServiceModel;
      this.errors = [];
      if (!item.name) this.errors.push('name');
      if (!item.description) this.errors.push('description');
      var newItem = this.activities.find(function (p) {
        return p.name.toUpperCase().trim() === item.name.toUpperCase().trim();
      });
      if (newItem && !item.id) {
        this.errors.push('name');
        this.$buefy.toast.open({
          message: 'Já existe um serviço com está nomeclatura, por favor verifique!',
          position: 'is-top',
          type: 'is-danger'
        });
      }
      if (!this.errors.length) {
        this.resolvedCalback();
      }
    },
    resolvedCalback: function () {
      var _resolvedCalback = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var action, data;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              action = this.isEdit ? this.editTypeService : this.saveNewTypeService;
              _context2.n = 1;
              return action(this.newServiceModel);
            case 1:
              data = _context2.v;
              if (!data) {
                _context2.n = 3;
                break;
              }
              _context2.n = 2;
              return this.getServiceTypes();
            case 2:
              this.$parent.close();
            case 3:
              return _context2.a(2);
          }
        }, _callee2, this);
      }));
      function resolvedCalback() {
        return _resolvedCalback.apply(this, arguments);
      }
      return resolvedCalback;
    }(),
    cancelModal: function cancelModal() {
      this.$parent.close();
    },
    getAsyncFarm: function () {
      var _getAsyncFarm = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(name) {
        var data;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              if (name.length) {
                _context3.n = 1;
                break;
              }
              this.farms = [];
              return _context3.a(2);
            case 1:
              _context3.n = 2;
              return this.fetchFarms({
                name: name
              });
            case 2:
              data = _context3.v;
              if (data) this.farms = _lodash.default.differenceBy(data, this.newServiceModel.farms, 'id');else this.farms = [];
            case 3:
              return _context3.a(2);
          }
        }, _callee3, this);
      }));
      function getAsyncFarm(_x) {
        return _getAsyncFarm.apply(this, arguments);
      }
      return getAsyncFarm;
    }(),
    onInsertFarm: function onInsertFarm(farm) {
      if (!farm) return null;
      var valid = this.newServiceModel.farms.filter(function (item) {
        return item.id === farm.id;
      });
      if (!valid.length) {
        this.newServiceModel.farms.push(farm);
        this.farms = [];
      } else {
        this.newServiceModel.farms = this.newServiceModel.farms.filter(function (item) {
          return item.id !== farm.id;
        });
      }
    },
    getAsyncProduct: function () {
      var _getAsyncProduct = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var data;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              _context4.n = 1;
              return this.fetchProducts();
            case 1:
              data = _context4.v;
              if (data) this.products = _lodash.default.differenceBy(data, this.newServiceModel.products, 'id');else this.products = [];
            case 2:
              return _context4.a(2);
          }
        }, _callee4, this);
      }));
      function getAsyncProduct() {
        return _getAsyncProduct.apply(this, arguments);
      }
      return getAsyncProduct;
    }(),
    getAsyncCustonFields: function () {
      var _getAsyncCustonFields = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(text) {
        var data;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              if (!text) {
                _context5.n = 2;
                break;
              }
              _context5.n = 1;
              return this.getCustomFields({
                filter: text
              });
            case 1:
              data = _context5.v;
              if (data) {
                this.listCustomFields = data.data;
              }
            case 2:
              return _context5.a(2);
          }
        }, _callee5, this);
      }));
      function getAsyncCustonFields(_x2) {
        return _getAsyncCustonFields.apply(this, arguments);
      }
      return getAsyncCustonFields;
    }(),
    confirmUnlinkCustomField: function confirmUnlinkCustomField(field, step) {
      this.dialogChange = this.$buefy.modal.open({
        parent: this,
        component: _DialogAlert.default,
        hasModalCard: true,
        canCancel: ['escape', 'outside'],
        props: {
          title: 'Desvincular campo?',
          message: 'Deseja realmente desvincular esse campo desse passo?',
          confirmText: 'Sim',
          onConfirm: this.unlinkCustomField,
          product: {
            field: field,
            step: step
          },
          type: 'is-danger'
        }
      });
    },
    unlinkCustomField: function () {
      var _unlinkCustomField = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(_ref) {
        var field, step, data;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              field = _ref.field, step = _ref.step;
              _context6.n = 1;
              return this.execUnlinkCustomField({
                idCustomField: field.id,
                idStepType: step.id
              });
            case 1:
              data = _context6.v;
              if (data) {
                this.getStepTypesLinked();
              }
            case 2:
              return _context6.a(2);
          }
        }, _callee6, this);
      }));
      function unlinkCustomField(_x3) {
        return _unlinkCustomField.apply(this, arguments);
      }
      return unlinkCustomField;
    }(),
    linkCustomFields: function () {
      var _linkCustomFields = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7(idStepType) {
        var payload, data;
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.n) {
            case 0:
              payload = {
                idStepType: idStepType.id,
                customFields: this.CFjoineds
              };
              _context7.n = 1;
              return this.execLinkCustomFields(payload);
            case 1:
              data = _context7.v;
              if (data) {
                this.selectedCustomFields = [];
                this.getStepTypesLinked();
              }
            case 2:
              return _context7.a(2);
          }
        }, _callee7, this);
      }));
      function linkCustomFields(_x4) {
        return _linkCustomFields.apply(this, arguments);
      }
      return linkCustomFields;
    }(),
    createServiceStep: function () {
      var _createServiceStep = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8(stepName) {
        var payload, data;
        return _regenerator().w(function (_context8) {
          while (1) switch (_context8.n) {
            case 0:
              payload = {
                name: stepName,
                serviceType: this.itemEdit.id
              };
              _context8.n = 1;
              return this.createServiceStepType(payload);
            case 1:
              data = _context8.v;
              if (data) {
                this.$buefy.toast.open("Passo criado com sucesso!");
                this.getStepTypesLinked();
              }
            case 2:
              return _context8.a(2);
          }
        }, _callee8, this);
      }));
      function createServiceStep(_x5) {
        return _createServiceStep.apply(this, arguments);
      }
      return createServiceStep;
    }(),
    openCreateNewStep: function openCreateNewStep() {
      var _this = this;
      this.$buefy.dialog.prompt({
        message: "Adicionar novo passo ao tipo de servi\xE7o <b>".concat(this.newServiceModel.name, "</b>?"),
        inputAttrs: {
          placeholder: 'Passo 1?'
        },
        trapFocus: true,
        onConfirm: function onConfirm(value) {
          return _this.createServiceStep(value);
        }
      });
    },
    deleteStep: function () {
      var _deleteStep = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee9(step) {
        var data;
        return _regenerator().w(function (_context9) {
          while (1) switch (_context9.n) {
            case 0:
              _context9.n = 1;
              return this.deleteServiceStepType(step);
            case 1:
              data = _context9.v;
              if (data) {
                this.$buefy.toast.open("Passo deletado com sucesso!");
                this.getStepTypesLinked();
              }
            case 2:
              return _context9.a(2);
          }
        }, _callee9, this);
      }));
      function deleteStep(_x6) {
        return _deleteStep.apply(this, arguments);
      }
      return deleteStep;
    }(),
    confirmDeleteStep: function confirmDeleteStep(step) {
      var _this2 = this;
      this.$buefy.dialog.confirm({
        message: "Tem certeza que deseja realente excluir o passo <b>".concat(step.name, "</b>?"),
        trapFocus: true,
        onConfirm: function onConfirm() {
          return _this2.deleteStep(step.id);
        }
      });
    }
  })
};